import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

type Props = {
  activeProScreens: number;
  visible: boolean;
};

/**
 * Inline amber banner shown when user is about to downgrade Pro → Standard
 * on the backgroundmusic add-on while Pro-paired screens are still active.
 */
export function TierDowngradeWarning({ activeProScreens, visible }: Props) {
  const { t } = useTranslation();
  if (!visible || activeProScreens <= 0) return null;

  return (
    <div
      role="alert"
      data-testid="tier-downgrade-warning"
      className="flex items-start gap-2 rounded-md border border-warning/30 bg-warning/10 dark:bg-warning/20 p-3 text-sm"
    >
      <AlertTriangle className="h-4 w-4 text-warning shrink-0 mt-0.5" />
      <p className="text-warning">
        {t('{{n}} screens will stop playing Pro stations.', { n: activeProScreens })}
      </p>
    </div>
  );
}
